import { render, staticRenderFns } from "./EmptyInfo.vue?vue&type=template&id=dbcfe8c0&scoped=true"
import script from "./EmptyInfo.vue?vue&type=script&lang=js"
export * from "./EmptyInfo.vue?vue&type=script&lang=js"
import style0 from "./EmptyInfo.vue?vue&type=style&index=0&id=dbcfe8c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcfe8c0",
  null
  
)

export default component.exports